import type { CSSProperties, ReactElement, ReactNode, Ref } from 'react';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CstretchmodalContentProps {
    bodyRef?: Ref<HTMLDivElement>;
    children?: ReactNode;
    dataElScope: DataElScope;
    style: CSSProperties;
}
export function CstretchmodalContent({ bodyRef, children, dataElScope, style, }: CstretchmodalContentProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'Content/Root')} ref={bodyRef ?? undefined} style={style}>
        {children}
      </div>
    );
}
